<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer008">
<p class="TOCtitle">Contents</p>
<p class="TOCitem"><a href="#/Prologue#_idTextAnchor000">Prologue</a></p>
<p class="TOCitem"><a href="#/Chapter_One#_idTextAnchor001">Chapter One</a></p>
<p class="TOCitem"><a href="#/Chapter_Two#_idTextAnchor002">Chapter Two</a></p>
<p class="TOCitem"><a href="#/Chapter_Three#_idTextAnchor003">Chapter Three</a></p>
<p class="TOCitem"><span href="#/Chapter_Four#_idTextAnchor004" title="Link target outside of Sample">Chapter Four</span></p>
<p class="TOCitem"><span href="#/Chapter_Five#_idTextAnchor005" title="Link target outside of Sample">Chapter Five</span></p>
<p class="TOCitem"><span href="#/Chapter_Six#_idTextAnchor006" title="Link target outside of Sample">Chapter Six</span></p>
<p class="TOCitem"><span href="#/Chapter_Seven#_idTextAnchor007" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="TOCitem"><span href="#/Chapter_Eight#_idTextAnchor008" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="TOCitem"><span href="#/Chapter_Nine#_idTextAnchor009" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="TOCitem"><span href="#/Chapter_Ten#_idTextAnchor010" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="TOCitem"><span href="#/Chapter_Eleven#_idTextAnchor011" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="TOCitem"><span href="#/Chapter_Twelve#_idTextAnchor012" title="Link target outside of Sample">Chapter Twelve</span></p>
<p class="TOCitem"><span href="#/Chapter_Thirteen#_idTextAnchor013" title="Link target outside of Sample">Chapter Thirteen</span></p>
<p class="TOCitem"><span href="#/Chapter_Fourteen#_idTextAnchor014" title="Link target outside of Sample">Chapter Fourteen</span></p>
<p class="TOCitem"><span href="#/Chapter_Fifteen#_idTextAnchor015" title="Link target outside of Sample">Chapter Fifteen</span></p>
<p class="TOCitem"><span href="#/Chapter_Sixteen#_idTextAnchor016" title="Link target outside of Sample">Chapter Sixteen</span></p>
<p class="TOCitem"><span href="#/Chapter_Seventeen#_idTextAnchor017" title="Link target outside of Sample">Chapter Seventeen</span></p>
<p class="TOCitem"><span href="#/Chapter_Eighteen#_idTextAnchor018" title="Link target outside of Sample">Chapter Eighteen</span></p>
<p class="TOCitem"><span href="#/Chapter_Nineteen#_idTextAnchor019" title="Link target outside of Sample">Chapter Nineteen</span></p>
<p class="TOCitem"><span href="#/Chapter_Twenty#_idTextAnchor020" title="Link target outside of Sample">Chapter Twenty</span></p>
<p class="TOCitem"><span href="#/Chapter_TwentyOne#_idTextAnchor021" title="Link target outside of Sample">Chapter Twenty-One</span></p>
<p class="TOCitem"><span href="#/Chapter_TwentyTwo#_idTextAnchor022" title="Link target outside of Sample">Chapter Twenty-Two</span></p>
<p class="TOCitem"><span href="#/Chapter_TwentyThree#_idTextAnchor023" title="Link target outside of Sample">Chapter Twenty-Three</span></p>
<p class="TOCitem"><span href="#/Chapter_TwentyFour#_idTextAnchor024" title="Link target outside of Sample">Chapter Twenty-Four</span></p>
<p class="TOCitem"><span href="#/Chapter_TwentyFive#_idTextAnchor025" title="Link target outside of Sample">Chapter Twenty-Five</span></p>
<p class="TOCitem"><span href="#/Chapter_TwentySix#_idTextAnchor026" title="Link target outside of Sample">Chapter Twenty-Six</span></p>
<p class="TOCitem"><span href="#/Chapter_TwentySeven#_idTextAnchor027" title="Link target outside of Sample">Chapter Twenty-Seven</span></p>
<p class="TOCitem"><span href="#/Chapter_TwentyEight#_idTextAnchor028" title="Link target outside of Sample">Chapter Twenty-Eight</span></p>
<p class="TOCitem"><span href="#/Chapter_TwentyNine#_idTextAnchor029" title="Link target outside of Sample">Chapter Twenty-Nine</span></p>
<p class="TOCitem"><span href="#/Chapter_Thirty#_idTextAnchor030" title="Link target outside of Sample">Chapter Thirty</span></p>
<p class="TOCitem"><span href="#/Chapter_ThirtyOne#_idTextAnchor031" title="Link target outside of Sample">Chapter Thirty-One</span></p>
<p class="TOCitem"><span href="#/Chapter_ThirtyTwo#_idTextAnchor032" title="Link target outside of Sample">Chapter Thirty-Two</span></p>
<p class="TOCitem"><span href="#/Chapter_ThirtyThree#_idTextAnchor033" title="Link target outside of Sample">Chapter Thirty-Three</span></p>
<p class="TOCitem"><span href="#/Epilogue#_idTextAnchor034" title="Link target outside of Sample">Epilogue</span></p>
<p class="TOCitem"><span href="#/Excerpt#_idTextAnchor035" title="Link target outside of Sample">Excerpt from <em>Missing in Blue Mesa</em> by Cindi Myers</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?0f511d08